import {createFileRoute} from '@tanstack/react-router';
import LeaguesView from '../../../../leagues/LeaguesView.tsx';

export const Route = createFileRoute('/_app/esports/leagues/$league_uid/$page')({
    component: RouteComponent,
})

function RouteComponent() {
    return <LeaguesView />
}
